import { SVGProps } from "react";

/** Small stroke icons used across the Studio. */
const PATHS = {
  back: "M15 18l-6-6 6-6",
  text: "M5 6V4h14v2M12 4v16M9 20h6",
  shapes:
    "M4 4h7v7H4zM17.5 4a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM7.5 14l4 6h-8zM14 14h6v6h-6z",
  upload: "M12 16V4M7 9l5-5 5 5M4 20h16",
  background: "M4 4h16v16H4zM4 15l5-5 4 4 3-3 4 4",
  layers: "M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5",
  undo: "M9 14L4 9l5-5M4 9h11a5 5 0 010 10h-3",
  redo: "M15 14l5-5-5-5M20 9H9a5 5 0 000 10h3",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  download: "M12 4v12M7 11l5 5 5-5M4 20h16",
  gallery: "M4 5h16v14H4zM8 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 16l-5-5-9 8",
  profile: "M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  copy: "M8 8h12v12H8zM4 16V4h12",
  lock: "M6 11h12v10H6zM8 11V8a4 4 0 018 0v3",
  unlock: "M6 11h12v10H6zM8 11V8a4 4 0 017.5-2",
  up: "M12 19V5M6 11l6-6 6 6",
  down: "M12 5v14M6 13l6 6 6-6",
  top: "M5 4h14M12 20V8M7 13l5-5 5 5",
  bottom: "M5 20h14M12 4v12M7 11l5 5 5-5",
  alignLeft: "M4 6h16M4 10h10M4 14h16M4 18h10",
  alignCenter: "M4 6h16M7 10h10M4 14h16M7 18h10",
  alignRight: "M4 6h16M10 10h10M4 14h16M10 18h10",
  close: "M6 6l12 12M18 6L6 18",
  play: "M7 4l13 8-13 8z",
  pause: "M7 4h4v16H7zM13 4h4v16h-4z",
  music:
    "M9 18V5l11-2v13M9 18a3 3 0 11-6 0 3 3 0 016 0zM20 16a3 3 0 11-6 0 3 3 0 016 0z",
  video: "M3 6h12v12H3zM15 10l6-4v12l-6-4",
  image: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4",
  scissors:
    "M6 9a3 3 0 100-6 3 3 0 000 6zM6 21a3 3 0 100-6 3 3 0 000 6zM20 4L8.1 15.9M14.5 14.5L20 20M8.1 8.1L12 12",
  sparkle: "M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z",
  check: "M5 12l5 5 9-10",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  center: "M12 3v18M3 12h18",
  flipH: "M12 3v18M8 7L3 12l5 5zM16 7l5 5-5 5z",
  volume: "M4 9h4l5-4v14l-5-4H4zM17 9a4 4 0 010 6",
  mute: "M4 9h4l5-4v14l-5-4H4zM17 9l4 6M21 9l-4 6",
  brand:
    "M12 3a9 9 0 100 18c1.1 0 1.5-.8 1.5-1.5 0-1.4-1.2-1.6-1.2-2.8 0-1 .8-1.7 1.7-1.7H17a4 4 0 004-4c0-4.4-4-8-9-8zM7.5 11.5h.01M10 7.5h.01M15 7.5h.01",
  draw: "M4 20l4-1L19 8a2.1 2.1 0 00-3-3L5 16l-1 4zM14 7l3 3",
  eraser: "M7 21h10M5 14l8-10a2 2 0 013 0l4 4a2 2 0 010 3l-8 10H8l-3-3a2 2 0 010-3zM11 7l7 7",
  pages: "M7 3h10v14H7zM4 7v14h10",
  history: "M3 12a9 9 0 103-6.7L3 8M3 3v5h5M12 7v5l3 3",
  resize: "M4 9V4h5M20 15v5h-5M4 4l7 7M20 20l-7-7",
  crop: "M6 2v14a2 2 0 002 2h14M2 6h14a2 2 0 012 2v14",
  wand: "M15 4V2M15 10V8M11 6H9M21 6h-2M17.8 3.2L19 2M17.8 8.8L19 10M12.2 3.2L11 2M3 21l9-9",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z",
  eyeOff:
    "M3 3l18 18M10.6 5.1A10 10 0 0112 5c6.5 0 10 7 10 7a17 17 0 01-3.2 4.2M6.6 6.6C3.9 8.4 2 12 2 12s3.5 7 10 7a9.7 9.7 0 005.4-1.6M9.9 9.9a3 3 0 004.2 4.2",
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  qr: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 18h2v2h-2zM14 18h2M18 14h2",
  search: "M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4",
  paint: "M4 4h13v5H4zM17 6.5h3v6h-8v3M10 15.5h4V21h-4z",
  flipV: "M3 12h18M7 8L12 3l5 5zM7 16l5 5 5-5z",
  rotate: "M20 11a8 8 0 10-2.3 6.3M20 4v7h-7",
  keyboard: "M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10",
  star: "M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z",
  photo: "M4 7h3l2-3h6l2 3h3v13H4zM12 17a4 4 0 100-8 4 4 0 000 8z",
  group: "M3 3h7v7H3zM14 14h7v7h-7zM10 7h4v7M7 10v4h7",
  ungroup: "M3 3h7v7H3zM14 14h7v7h-7z",
  alignTop: "M4 3h16M8 7h3v13H8zM14 7h3v7h-3z",
  alignMiddle: "M4 12h16M8 5h3v14H8zM14 8h3v8h-3z",
  alignBottom: "M4 21h16M8 4h3v13H8zM14 10h3v7h-3z",
  alignL: "M3 4v16M7 7h13v3H7zM7 14h7v3H7z",
  alignC: "M12 4v16M5 7h14v3H5zM8 14h8v3H8z",
  alignR: "M21 4v16M4 7h13v3H4zM10 14h7v3h-7z",
  distH: "M4 4v16M20 4v16M10 7h4v10h-4z",
  distV: "M4 4h16M4 20h16M7 10h10v4H7z",
  eyedropper:
    "M19 5a2.8 2.8 0 00-4 0l-2 2-1-1-2 2 1 1-7 7v3h3l7-7 1 1 2-2-1-1 2-2a2.8 2.8 0 000-4z",
  cloud: "M7 18a5 5 0 01-.5-10A6 6 0 0118 9a4.5 4.5 0 01-.5 9z",
  file: "M6 3h8l4 4v14H6zM14 3v4h4",
  template: "M4 4h16v6H4zM4 14h7v6H4zM15 14h5v6h-5z",
  case: "M5 7h3M6.5 7v10M11 17l3.5-10 3.5 10M12.2 13.5h4.6",
  line: "M4 20L20 4",
  link: "M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1",
} as const;

export type IconName = keyof typeof PATHS;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "stroke" | "width" | "height"> {
  name: IconName;
  size?: number;
  stroke?: number;
}

export function Icon({ name, size = 20, stroke = 1.8, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
